export const modalCloseButtonStyle = {
  outlineColor: "transparent",
  outline: "none",
  boxShadow: "none",
};
